import { Fragment } from 'react'
import { cn } from '@/lib/utils'

/** Comma-separated author list with the site owner emphasised. */
export function AuthorList({ authors, highlight, className }: { authors: string[]; highlight: string; className?: string }) {
  return (
    <p className={cn('text-sm text-zinc-400', className)}>
      {authors.map((a, i) => (
        <Fragment key={a}>
          {a === highlight ? <span className="font-medium text-zinc-100 underline decoration-lilac/60 underline-offset-4">{a}</span> : a}
          {i < authors.length - 1 && ', '}
        </Fragment>
      ))}
    </p>
  )
}
